export const localeNl = {
  general: {
    _administration: 'Administratie',
    _username: 'Gebruikersnaam',
    _password: 'Wachtwoord',
    _date: 'Datum',
    _time: 'Tijd',
    _orderOverview: 'Bestellingsoverzicht',
    _smartMap: 'Kaart',
    _reports: 'Rapporten',
    _kg: 'kg',
    _ton: 'ton',
    _callOrder: 'Oproeporders',
    _serviceList: 'Werklijst',
    _impersonationManager: 'Stel klant/gebruiker in',
    _userAdmin: 'Gebruikersbeheer',
    _routeAdmin: 'Routes',
    _routeAdministration: 'Routebeheer',
    _backendError: 'Er is een fout opgetreden bij het verzoek',
    _accessError: 'Je hebt geen toegang tot deze pagina',
    _vehicles: 'Voertuigen',
    _vehicleSettings: 'Administratieve Instellingen',
    _zoomIn: 'Inzoomen',
    _zoomOut: 'Uitzoomen',
    _warning: 'Waarschuwing!',
    _customerRegister: 'Zoek in klantenregister',
    _commune: 'Gemeente',
    _logOut: 'Uitloggen',
    _selectLanguage: 'Selecteer taal',
    _unitDesrciption: 'Eenheidstype',
    _fullDateFormat: 'dd.MM.yyyy',
    _fullDateWithTime: 'dd.MM.yyyy HH:mm:ss',
    _fullMomentFormat: 'DD.MM.YYYY',
    _fullMomentWithTime: 'DD.MM.YYYY HH:mm:ss',
    _noRecords: 'Geen records beschikbaar.',
    _dashboard: 'Dashboard',
    _decimalSeparator: ',',
    _loading: 'Laden',
    validation: {
      _isRequired: 'is vereist',
      _stringMaxCharA: 'moet maximaal',
      _stringMaxCharB: 'tekens zijn',
      _emailNotValid: 'is geen geldig e-mailadres!',
      _lessOrEqual: 'moet kleiner dan of gelijk zijn aan',
      _greaterOrEqual: 'moet groter dan of gelijk zijn aan',
      _laterThan: 'moet later zijn dan',
      _earlierThan: 'moet eerder zijn dan',
    },
  },
  login: {
    _usernameEmail: 'E-mail',
    _usernameRequired: 'Gebruikersnaam is verplicht!',
    _passwordRequired: 'Wachtwoord is verplicht!',
    _usernamePasswordInvalid: 'Ongeldige gebruikersnaam of wachtwoord',
    _invalidEmail: 'Gebruikersnaam is geen geldig e-mailadres!',
    _submit: 'Inloggen',
    _welcome: 'Welkom bij GPS Realtime WMS',
    _pressLogin: 'Klik op Inloggen om in te loggen op het portaal',
    _ifAssistance: 'Indien hulp nodig,',
    _pleaseContact: 'neem gerust contact op met onze support',
  },
  tooltip: {
    _deviceId: 'Apparaatnummer',
    _altitude: 'Hoogte',
    _speed: 'Snelheid',
    _temperature: 'Temperatuur',
    _orderId: 'Ordernummer',
    _address: 'Adres',
    _routeName: 'Route',
  },
  orders: {
    _update: 'Bijgewerkt',
    _start: 'Start',
    _route: 'Route',
    _vehicleId: 'Voertuig',
    _orderId: 'Bestelling',
    _status: 'Status',
    _notStarted: 'Niet gestart',
    _now: 'Nu',
    _clearFilter: 'Filter wissen',
    _fraction: 'Fractie',
    _showFilters: 'Filters weergeven',
    _chooseContractor: 'Kies vervoerder',
    _chooseFraction: 'Kies fractie',
    _chooseStatus: 'Kies status',
    _expires: 'Verloopt',
    _date: 'Datum',
    _ordinaryDate: 'Gewone datum',
    _ordinaryDateValidation:
      'Gewone datum moet gelijk zijn aan of na {date}.',
    _earlierDateValidation:
      'Vervaldatum moet gelijk zijn aan of na de gewone datum.',
    _fractions: 'Fracties',
    _selectFractions: 'Selecteer fracties',
    _noFractions: 'Geen fracties',
    _updateOrder: 'Update bestelling',
    _updateSuccess: 'Bestelling is bijgewerkt',
    _fractionsLoading: 'Fracties worden geladen',
    _notEditableWarning:
      'Zodra de route is gestart, kan alleen de vervaldatum worden gewijzigd.',
    _contractor: 'Aannemer',
    _customerGroup: 'Klantengroep',
    _newOrder: 'Nieuwe bestelling',
    _dynamic: 'Dynamisch',
    _dynamicOrderWarning:
      'Bestelling wordt aangemaakt en verschoven op basis van de opgegeven uitsluitingen.',
    _dynamicOrderWarningLink: 'Klik hier om uitsluitingen te beheren',
    _selectContractor: 'Selecteer Aannemer',
    _selectRoute: 'Selecteer Route',
    _selectFractions: 'Selecteer Fractie/Afvaltype',
    _selectCustomerGroup: 'Selecteer Klantengroep',
    _selectFrequency: 'Selecteer Frequentie',
    _selectDays: 'Selecteer Dag(en)',
    _days: 'Dag(en)',
    _startDate: 'Startdatum',
    _ordinaryDate: 'Voer Gewoonlijke Datum In',
    _expireDate: 'Voer Vervaldatum In',
    _repetationEndDate: 'Herhalings Einddatum',
    _frequency: 'Frequentie',
    _addOrderButton: 'Bestelling(en) aanmaken',
    _saveOrderButton: 'Opslaan',
    status: {
      _noDone: 'Niet voltooid',
      _okDone: 'Ok, voltooid',
      _downloaded: 'Gedownload',
      _started: 'Gestart',
      _backOrder: 'Achterstallige bestelling',
      _localBackOrder: 'Lokale achterstallige bestelling',
      _partiallyStarted: 'Gedeeltelijk gestart',
      _partiallyCompleted: 'Gedeeltelijk voltooid',
      _rejected: 'Afgewezen',
      _planned: 'Gepland',
      _deleted: 'Verwijderd',
    },
  },
  orderDetails: {
    _address: 'Adres',
    _unit: 'Eenheid',
    _executed: 'Uitgevoerd',
    _vehicleId: 'Voertuig',
    _driver: 'Chauffeur',
    _time: 'Tijd',
    _deviation: 'Afwijking',
    _orderDoesNotExist: 'De bestelling bestaat niet',
    _companyName: 'Klant',
    _pictureTakenText: "foto's",
    _sequence: 'Volgorde',
    _isCallOrder: ' ',
  },
  orderStatuses: {
    _started: 'Gestart',
    _done: 'OK, gereden',
    _partiallyDone: 'Gedeeltelijk voltooid',
  },
  orderDetailsDiagram: {
    _executionStatusHeader: 'Uitgevoerd (Ja / Nee)',
    _deviationsHeader: 'Afwijkingen / Opmerkingen',
    _noDeviations: 'Geen afwijkingen / opmerkingen',
  },
  routeStopDetails: {
    _routeStopDoesNotExist: 'De halte bestaat niet',
    _departureTime: 'Vertrektijd',
    _arrivalTime: 'Aankomsttijd',
    _address: 'Adres',
    _agreementId: 'OvereenkomstNr',
    _unit: 'Eenheid',
    _agreementLineId: 'BehNr',
    _executed: 'Uitgevoerd',
    _externalOrderId: 'BestellingNr',
    _vehicleId: 'Voertuig',
    _driver: 'Chauffeur',
    _orderData: 'Bestelgegevens',
    _pictures: "Foto's",
    _deviation: 'Afwijking / Opmerking',
    _comment: 'Opmerking',
  },
  routeAdminPage: {
    _selectRoute: 'Selecteer route(s)',
    _refresh: 'Verversen',
    _withoutPosition: 'Zonder positie',
    _sequence: 'Volgorde',
    _description: 'Beschrijving',
    _routeLineId: 'Halte',
    _agreementId: 'Overeenkomst-id',
    _name: 'Naam',
    _estate: 'Eigendom',
    _unitName: 'Product',
    _agreementLineId: 'Overeenkomstregel-id',
    _physicalAmount: 'Aantal',
    _route: 'Route',
    _degLat: 'Breedtegraad',
    _degLong: 'Lengtegraad',
    _invalidSequence: 'Ongeldig volgnummer',
    _changeSequence: 'Verander volgorde',
    _cancelButton: 'Annuleren',
    _submitButton: 'Opslaan',
    _validateButton: 'Valideren',
    _restoreButton: 'Annuleren',
    _locationChangeTitle: 'Weet je zeker dat je wilt opslaan?',
    _locationChangeContent: 'Je wijzigingen worden nu opgeslagen',
    _splitStoppoint: 'Halte splitsen',
    _splitModalPlaceholder:
      'Sleep een klant hierheen om een nieuwe halte te maken',
    _splitModalErrorMessage: 'Je moet minstens 2 haltes maken',
    _mergeModalTitle: 'Haltes samenvoegen',
    _mergeModalContent: 'Geselecteerde haltes',
    _selectOnlyOne: 'Selecteer alstublieft slechts 1 halte',
    _selectAtLeastOne: 'Minstens 1 halte moet geselecteerd worden',
    _selectAtLeastTwo: 'Minstens 2 haltes moeten geselecteerd worden',
    _mergeStoppoints: 'Halten samenvoegen',
    _sequenceEdit: 'Volgorde wijzigen',
    _savePosition: 'Positie opslaan',
    _changePosition: 'Positie wijzigen',
    _changePositionTooltip: 'Wijzig de positie van de geselecteerde halte',
    _agreementGid: 'GnrBnrFnrSnr',
    _placeId: 'Halte-ID',
    _address: 'Adres',
    _customerName: 'Klantnaam',
    _propertyLinesWarning: 'Sommige punten kunnen buiten de kaart verschijnen.',
    _propertyLinesCustom: 'Toon alleen punten met coördinaten.',
    _propertyLinesAll: 'Toon alle punten.',
    _changesHeader: 'De volgende volgordenummers worden beïnvloed',
    _changedFrom: 'veranderd van',
    _changedTo: 'naar',
    _notInNorwayErrorMessage: 'De ingestelde positie ligt buiten Noorwegen',
    _alreadyMerged: 'Geselecteerde afspraken zijn al samengevoegd',
    _mergeModalTargetText: 'Selecteer weergave/adres van de halte',
    _mergeModalTargetDropdownText: 'Selecteer welke weergave/adres',
    _setPosition: 'Positie instellen',
    _setPositionTooltip: 'Positie instellen voor geselecteerde halte',
    _noRecords: 'Geen records beschikbaar.',
    _isLoadingMessage: 'Records worden geladen.',
    _sequenceSuccessfullyChanged: 'Volgorde is bijgewerkt',
    _remove: 'Verwijderen',
    _selection: 'keuze',
    _hideWithoutAgreement: 'Verbergen zonder overeenkomst',
    _chooseRoutes: 'Kies routes',
  },
  reports: {
    _exportTitle: 'Exporteer naar Excel-bestand',
    _nothingToExportTitle: 'Geen gegevens om te exporteren',
    _showReport: 'Toon rapport',
    _fromDate: 'Van datum',
    _toDate: 'Tot datum',
    _selectReport: 'Selecteer rapport',
    _reportEmpty: 'Geen records beschikbaar',
    _header: 'Mijn rapporten',
    _summary:
      'Hier hebben we al uw rapporten verzameld. Rapporten kunnen worden besteld bij onze consultants. Neem contact met ons op via e-mail {mailto}.',
    _export: 'Exporteren',
  },
  serviceLists: {
    _noOrders: 'Geen bestellingen gepland.',
    _delete: 'Verwijderen',
    _add: 'Toevoegen',
    _deleteConfirm: 'Weet je zeker dat je deze werklijst wilt verwijderen: ',
  },
  routeOptimalizationWizard: {
    _title: 'Maak ritlijsten',
    _uploadFileStep: 'Bestand uploaden',
    _uploadFileButton: 'Selecteer bestand',
    _loadInButton: 'Inladen',
    _analyseStep: 'Analyseren',
    _analyseButton: 'Voer analyse uit',
    _saveStep: 'Ritlijsten',
    _saveButton: 'Maak ritlijsten',
    _downloadTemplateButton: 'Download importtemplate',
    _importedRouteTabTitle: 'Bestelbasis',
    _worklistsTabTitle: 'Ritlijsten',
    _unassignedStopsTabTitle: 'Bestellingen niet inbegrepen',
    _noRoutesImported: 'Geen bestellingen, upload bestand',
    _worklistEmpty: 'De ritlijst is leeg',
    _worklistOptionText: 'Ritroute',
    _addCustomer: 'Klant toevoegen',
    _duplicateRoutesWarning: 'Er zijn dubbele bestellingen in de bestelbasis',
    _noFileSelectedTitle: 'Geen bestand geselecteerd!',
    _noFileSelectedDescription:
      'Upload de bestelbasislijst met de volgende importtemplate:',
    _avaibleOrders: 'Beschikbare bestellingen',
    _loadIn: 'Laden in',
    _loadOrders: 'Bestellingen laden',
    importManager: {
      _unknownParseError: 'Onbekende fout opgetreden',
      _fileLoadResultsModalTitle: 'Bestand laadresultaten',
      _fileLoadSuccess: 'Bestand succesvol geladen!',
      _fileLoadModalCloseButton: 'Sluiten',
      _agreementNotFound: 'Klanten niet gevonden voor klantnr',
      _wrongFileFormat: 'Verkeerd bestandformaat. Download importtemplate',
      _fileEmpty: 'Het bestand bevat geen gegevens',
    },
    addCustomerModal: {
      _title: 'Klant toevoegen',
      _closeButton: 'Sluiten',
      _addButton: 'Toevoegen',
      _dateLabel: 'Datum',
      _agreementLabel: 'Klant',
      _descriptionLabel: 'Beschrijving',
      _serialLabel: 'Serienummer',
      _noOptionsMessage: 'Geen klanten gevonden',
      _loadingMessage: 'Klanten worden geladen',
      _agreementSelector: 'Selecteer klant',
      _agreementSelectorPlaceholder: 'Selecteer klant...',
    },
    routeAnalysisModal: {
      _title: 'Analyseer bestelbasis',
      _closeButton: 'Sluiten',
      _cancelButton: 'Annuleren',
      _analyseButton: 'Analyseren',
      _selectStartAndStop: 'Selecteer start- en eindpunt',
      _workTime: 'Effectieve werktijd',
      _timePerStop: 'Tijd per stop (minuten)',
      _maximumCars: "Maximaal aantal auto's in analyse",
      _startStopLabel: 'Start- en eindpunt',
      _workHoursLabel: 'Uren',
      _workMinutesLabel: 'Minuten',
      _timePerStopLabel: 'Tijd per stop',
      _maximumCarsLabel: "Maximaal aantal auto's",
      _noDepotOptionsMessage: 'Geen depots gevonden',
      _depotsLoadingMessage: 'Depots worden geladen',
      _depotSelectorPlaceholder: 'Selecteer depot...',
      _analysationError: 'Fout bij het analyseren van de bestelbasis',
    },
    routesGrid: {
      _date: 'Datum',
      _gln: 'Contractnr',
      _customerName: 'Klantnaam',
      _description: 'Beschrijving',
      _serial: 'Serienummer',
      _orderNumber: 'Bestelnummer',
      _executionBefore: 'Uitvoering vóór',
      _executionAfter: 'Uitvoering na',
    },
    worklistResults: {
      _sequence: 'Volgorde',
      _arrivalTime: 'Tijd',
      _gln: 'Klantnr',
      _customerName: 'Klantnaam',
      _description: 'Beschrijving',
      _serial: 'Serienummer',
      _unassignedWarning: 'bestellingen niet inbegrepen!',
      worklistSummary: {
        _totalTime: 'Totale tijd',
      },
      moveWorklistItemModal: {
        _title: 'Verplaats naar',
        _targetListLabel: 'Ritlijst',
        _closeButton: 'Sluiten',
        _moveButton: 'Verplaats naar',
      },
    },
    createWorklistsModal: {
      _title: 'Maak ritlijsten',
      _closeButton: 'Sluiten',
      _saveButton: 'Maak aan',
      _itemCount: 'Aantal',
      _listName: 'Lijstnaam',
      _saveError: 'Fout bij het maken van ritlijsten',
    },
    filterOrderTypes: {
      _extraEmptying: 'Extra lediging',
      _collectUnit: 'Eenheid ophalen',
      _additionalServicePickup: 'Aanvullende service ophaalpunt',
      _emptying: 'Lediging',
      _markSteel: 'Staal markeren',
      _replaceUnit: 'Eenheid vervangen',
      _replaceChip: 'Chip vervangen',
      _urgentEmptying: 'Spoedlediging',
      _routeExtraEmptying: 'Extra lediging op route',
      _createLabel: 'Label aanmaken',
      _regularEmptying: 'Reguliere lediging',
      _placeUnit: 'Plaats eenheid',
      _serviceOrder: 'Serviceorder',
      _serviceAgreement: 'Serviceovereenkomst',
      _salesOrder: 'Verkooporder',
      _routePlanning: 'Routeplanning',
      _slamRegularEmptying: 'SLAM - Reguliere lediging',
      _slamOffRouteEmptying: 'SLAM - Lediging buiten route',
      _slamEmergencyEmptying: 'SLAM - Spoedlediging',
      _slamFlushing: 'SLAM - Spoelen',
      _slamImmediateHelp: 'SLAM - Directe hulp',
      _slamFixedWeekEmptying: 'SLAM - Wekelijkse lediging',
      _extraSweeping: 'Extra vegen',
      _extraInspection: 'Extra inspectie',
      _all: 'Alle',
      _selectOrderType: 'Selecteer ordertype',
    },
  },
  dateRangePicker: {
    _thisWeek: 'Deze week',
    _lastWeek: 'Vorige week',
    _thisMonth: 'Deze maand',
  },
  serviceListsGrid: {
    _listName: 'Lijstnaam',
    _vehicleId: 'Voertuig',
    _updated: 'Bijgewerkt',
    _started: 'Start',
    _listDate: 'Datum',
  },
  serviceOrders: {
    _noOrders: 'Geen bestellingen gepland.',
    _excelExportButton: 'Excel',
    _pdfExportButton: 'PDF',
    _deleteConfirm: 'Weet je zeker dat je deze bestelling wilt verwijderen: ',
  },
  serviceOrdersGrid: {
    _updated: 'Tijd',
    _address: 'Adres',
    _executed: 'Uitgevoerd',
    _unit: 'Eenheid',
    _orderItemType: 'Type',
    _deviation: 'Afwijking',
    _orderNumber: 'Bestelnummer',
    _sequence: 'Volgorde',
    _agreementCompanyName: 'Klant',
    _estimatedArrivalTime: 'Verwacht',
  },
  serviceOrderDetails: {
    _serviceOrders: 'Werkorders',
  },
  serviceOrderDetailsGrid: {
    _agreementCompanyName: 'Klant',
    _address: 'Adres',
    _externalOrderId: 'GLN',
    _sequence: 'Volgorde',
    _estimatedArrivalTime: 'Verwacht',
    _description: 'Beschrijving',
    _listDescription: 'Lijstbeschrijving',
    _executed: 'Uitgevoerd',
    _vehicleId: 'Voertuig',
    _updated: 'Uitvoertijd',
    _unitName: 'Eenheid',
    _orderItemType: 'Type',
    _time: 'Tijd',
  },
  containerOrders: {
    _noOrders: 'Geen bestellingen gepland.',
    _addVehicle: 'Voeg voertuig toe',
    _cancel: 'Annuleren',
    _save: 'Voertuig toewijzen',
    _addVehicleSuccess: 'Voertuig toegevoegd',
    _addVehicleFailure: 'Voertuig is niet ingesteld',
    _dateRange: 'Datumbereik',
    _routes: 'Routes',
    _selectRoutes: 'Selecteer routes',
    _vehicles: 'Voertuigen',
    _selectVehicles: 'Selecteer voertuigen',
    _customInterval: 'Aangepast interval',
    _fromDate: 'Van datum',
    _toDate: 'Tot datum',
    _maxRangeWarning: 'Maximaal bereik is 30 dagen',
    _intervalWarning: 'Van datum kan niet na Tot datum liggen',
    _lastSevenDays: 'Laatste 7 dagen',
    _lastThirtyDays: 'Laatste 30 dagen',
  },
  containerOrdersGrid: {
    _orderId: 'Bestel ID',
    _expires: 'Verloopt',
    _date: 'Datum',
    _routeName: 'Route',
    _address: 'Adres',
    _unitName: 'Eenheid',
    _orderTypeName: 'Type',
    _fraction: 'Fractie',
    _vehicleId: 'Voertuig',
    _route: 'Bestelroute',
  },
  customerSearchGrid: {
    _id: 'Id',
    _system: 'Systeem',
    _municipality: 'Gemeente',
    _name: 'Naam',
    _address: 'Adres',
    _zipCode: 'Postcode',
    _type: 'Profieltype',
    _unitDesrciption: 'Eenheidstype',
    _sendMessage: 'Stuur directe bericht',
  },
  containerOrderDetails: {
    _unitName: 'Eenheid',
    DetailData_Name: 'Naam',
    DetailData_Address1: 'Adres 1',
    DetailData_Address2: 'Adres 2',
    DetailData_PostalCode: 'Postcode',
    DetailData_Other: 'Overig',
    DetailData_Message: 'Opmerking',
    DetailData_OrderId: 'Bestel id',
    DetailData_Expires: 'Verloopt',
    DetailData_LastDate: 'Laatste datum',
    DetailData_LastVolume: 'Volume',
    DetailData_MessageSeptic: 'Opmerking',
    DetailData_Material: 'Materiaaltype',
    DetailData_NumberOfChambers: 'Aantal kamers',
    DetailData_TubeLength: 'Slanglengte',
    DetailData_ExtOrderId: 'Bestel id',
    DetailData_ExtOrderNr: 'Extern bestelnummer',
    DetailData_Route: 'Route',
    DetailData_RouteName: 'Routenaam',
    DetailData_OrderDate: 'Besteldatum',
    DetailData_OrderType: 'Besteltype',
    DetailData_OrderTypeText: 'Besteltype',
    DetailData_PASystem: 'PASysteem',
    DetailData_AgreementLines: 'Overeenkomstregels',
    DetailData_RoutelineId: 'Routelijn-id',
    AgreementLineDetailData_PASystem: 'PASysteem',
    AgreementLineDetailData_AgreementId: 'Overeenkomst-id',
    AgreementLineDetailData_AgreementLineId: 'Overeenkomstregel-id',
    AgreementLineDetailData_UnitId: 'Eenheid-id',
    AgreementLineDetailData_Amount: 'Bedrag',
    AgreementLineDetailData_PhysicalAmount: 'Fysiek bedrag',
    AgreementLineDetailData_Message: 'Plaatsing',
    AgreementLineDetailData_ExtOrderId: 'Bestel id',
    AgreementLineDetailData_LastChanged: 'Laatst gewijzigd',
    AgreementLineDetailData_DegLat: 'Breedtegraad',
    AgreementLineDetailData_DegLon: 'Lengtegraad',
    AgreementLineDetailData_ContainerId: 'Container-id',
    AgreementLineDetailData_Fraction: 'Fractie',
    AgreementDetailData_PASystem: 'PASysteem',
    AgreementDetailData_AgreementId: 'Overeenkomst-id',
    AgreementDetailData_Route: 'Route',
    AgreementDetailData_CustomerId: 'Klant-id',
    AgreementDetailData_Name: 'Naam',
    AgreementDetailData_ContactName: 'Contactnaam',
    AgreementDetailData_Address1: 'Adres 1',
    AgreementDetailData_Address2: 'Adres 2',
    AgreementDetailData_PostalCode: 'Postcode',
    AgreementDetailData_City: 'Stad',
    AgreementDetailData_Other: 'Overig',
    AgreementDetailData_Message: 'Opmerking',
    AgreementDetailData_Type: 'Type',
    AgreementDetailData_LastChanged: 'Laatst gewijzigd',
  },
  impersonationManager: {
    _selectUser: 'Kies klant/gebruiker',
    _noOptionsMessage: 'Geen gebruikers gevonden',
    _impersonate: 'Gebruik',
    _stopImpersonation: 'Stop met gebruiken',
    _selectUserPlaceholder: 'Kies klant/gebruiker...',
  },
  userAdmin: {
    _noUsers: 'Geen gebruikers beschikbaar',
    _userName: 'E-mail',
    _system: 'Systeem',
    _contractor: 'Aannemer',
    _contractorId: 'Transporteur',
    _localAdmin: 'Lokaal beheerder',
    _admin: 'Beheerder',
    _modules: 'Modulen',
    _add: 'Toevoegen',
    _update: 'Bijwerken',
    _cancel: 'Annuleren',
    _newUser: 'Nieuwe gebruiker toevoegen',
    _userEditDialogTitle: 'Bewerk gebruiker',
    _userAddDialogTitle: 'Nieuwe gebruiker toevoegen',
    _password: 'Wachtwoord',
    _passwordConfirmation: 'Bevestig wachtwoord',
    _confirmPasswordError: 'Wachtwoorden moeten overeenkomen',
    _noCustomerOptionsMessage: 'Geen klanten gevonden',
    _noContractorOptionsMessage: 'Geen aannemers gevonden',
    _contractorsLoadingMessage: 'Aannemers worden geladen',
    _noModuleOptionsMessage: 'Geen modules gevonden',
    _modulesLoadingMessage: 'Modules worden geladen',
    _customerSelectorPlaceholder: 'Kies klant...',
    _impersonationWarningPart1: 'Je bent ingelogd als ',
    _impersonationWarningPart2:
      ', en hebt geen rechten om deze pagina te gebruiken. Klik op de knop hieronder om terug te gaan naar de beheerdersfunctie.',
  },
  vehicles: {
    _noVehicles: 'Geen voertuigen beschikbaar',
    _vehicles: 'Voertuigen',
    _system: 'Systeem',
    _DTAShort: 'DTA',
    _DTALong: 'Digitale Truck Assistant',
    _ajourShort: 'Ajour',
    _ajourLong: 'GPS Ajour',
    _vehicleId: 'Voertuig',
    _externalId: 'Extern Id',
    _description: 'Beschrijving',
    _phoneNr: 'SIM Nr',
    _driver: 'Chauffeur',
    _password: 'Wachtwoord',
    _repeatPassword: 'Herhaal wachtwoord',
    _edit: 'Bewerken',
    _cancel: 'Annuleren',
    _update: 'Bijwerken',
    _submit: 'Opslaan',
    _addNewVehicle: 'Voeg nieuw voertuig toe',
    _editMessageSuccessful: 'Voertuig bijgewerkt',
    _addMessageSuccessful: 'Voertuig toegevoegd',
    _editMessageFailed: 'Fout bij het bijwerken van voertuig',
    _addMessageFailed: 'Fout bij het toevoegen van voertuig',
    _vehicleAlreadyExistingError: 'Een voertuig met dezelfde naam bestaat al',
    _validationError: 'Alleen cijfers en letters zijn toegestaan',
    _contractorSelectorPlaceholder: 'Kies aannemer...',
    _noContractorFound: 'Geen aannemers beschikbaar',
    _vehicleLoadingMessage: 'Voertuigen worden geladen',
  },
  vehicleSettings: {
    _copyFromVehicleButton: 'Kopieer van...',
    _copyFromVehicleDialogTitle: 'Kopieer instellingen van gebruiker',
    _copyButton: 'Kopieer',
    _copyFromVehicleError: 'Fout bij het kopiëren van gebruikersinstellingen',
    _copyFromVehicleSuccess:
      'Instellingen zijn gekopieerd van de geselecteerde gebruiker',
    _noSettings: 'Geen instellingen beschikbaar',
    _parameter: 'Parameter',
    _value: 'Waarde',
    _addToMultiple: 'Aan meerdere voertuigen toevoegen?',
    _description: 'Beschrijving',
    _vehicle: 'Voertuig',
    _edit: 'Bewerken',
    _cancel: 'Annuleren',
    _multiselectError: 'Selecteer minimaal één voertuig',
    _update: 'Bijwerken',
    _submit: 'Opslaan',
    _addNewSetting: 'Voeg nieuwe instelling toe',
    _editMessageSuccessful: 'Gebruikersinstelling bijgewerkt',
    _addMessageSuccessful: 'Gebruikersinstelling toegevoegd',
    _deleteMessageSuccessful: 'Gebruikersinstelling verwijderd',
    _editMessageFailed: 'Fout bij het wijzigen van gebruikersinstelling',
    _addMessageFailed: 'Fout bij het toevoegen van gebruikersinstelling',
    _deleteMessageFailed: 'Fout bij het verwijderen van gebruikersinstelling',
    _deleteConfirm:
      'Weet je zeker dat je deze gebruikersinstelling wilt verwijderen',
    _vehicleSelectorPlaceholder: 'Kies voertuig...',
    _selectVehicle: 'Voertuig',
    _selectCustomer: 'Klant',
    _selectContractor: 'Aannemer',
    _settingTemplateSelectorPlaceholder: 'Kies instellingstype...',
    _noSettingTemplateOptionsMessage: 'Geen instellingen gevonden',
    _cannotAddNewSettingMessage:
      'Kan geen instellingen toevoegen. Alle instellingen zijn al aanwezig.',
    _failedToLoadSettingTempletes:
      'Kan instellingen niet wijzigen of toevoegen. Standaardinstellingen ontbreken.',
  },
  map: {
    _trackingLineLayer: 'Trackinglijn',
    _trackInfo: 'GPS-informatie',
    _trackInfoLine: 'GPS Sporlogboek',
    _trackInfoPointsAndLines: 'Sporlogboek',
    _streetLayer: 'Basiskaart',
    _satelliteLayer: 'Luchtfoto',
    _propertyLayer: 'Kadastrale weergave',
    _wmsLayer: 'WMS',
    _nWMSLayersSelected: '{0} Gebied(en) geselecteerd',
    _lastUpdated: 'Bijgewerkt',
    _routes: 'Routes',
    _getAgreements: 'Overeenkomsten ophalen',
    _agreemenets: 'Overeenkomsten',
    _trackingLineLegend: {
      _belowSix: '< 6 uur',
      _sixToTwelve: '6-12 uur',
      _twelveToTwentyFour: '12-24 uur',
      _overTwentyFour: '> 24 uur',
      _gray: 'Onbekend',
    },
  },
  contractors: {
    _contractors: 'Aannemers',
    _name: 'Naam van de aannemer',
    _externalId: 'Externe aannemer-id',
    _addContractor: 'Voeg nieuwe aannemer toe',
    _deleteConfirm: 'Weet je zeker dat je deze aannemer wilt verwijderen: ',
    _deleteSuccess: 'Aannemer verwijderd',
    _addSuccess: 'Aannemer toegevoegd',
    _editSuccess: 'Aannemer bijgewerkt',
  },
  deviations: {
    _deviations: 'Afwijkingen',
    _deviation: 'Afwijking',
    _deviatonExtId: 'Afwijking externe Id',
    _category: 'Categorie',
    _deleteConfirm: 'Weet je zeker dat je deze afwijking wilt verwijderen: ',
    _addNew: 'Voeg afwijking toe',
    _addSuccess: 'Afwijking toegevoegd',
    _editSuccess: 'Afwijking bijgewerkt',
    _deleteSuccess: 'Afwijking verwijderd',
    _selectCategory: 'Selecteer afwijkingscategorie',
    _noCategory: 'Geen afwijkingscategorie gevonden',
    _deleteCategoryConfirm:
      'Weet je zeker dat je deze afwijkingscategorie wilt verwijderen: ',
    _categoryDeleteSuccess: 'Afwijkingscategorie verwijderd',
    _deviationCategory: 'Afwijkingscategorieën',
    _categoryName: 'Naam van afwijkingscategorie',
    _addCategorySuccess: 'Afwijkingscategorie toegevoegd',
    _editCategorySuccess: 'Afwijkingscategorie bijgewerkt',
    _addNewCategory: 'Voeg nieuwe afwijkingscategorie toe',
  },
  customerRegister: {
    message: {
      _directMessageToCustomer: 'Directe boodschap naar klant',
      _address: 'Adres',
      _sender: 'Afzender',
      _expires: 'Verloopt',
      _vehicle: 'Voertuig',
      _selectVehicle: 'Kies voertuig',
      _title: 'Titel',
      _message: 'Boodschap',
      _send: 'Verzenden',
      _messageSent: 'Boodschap verzonden',
      _noVehicle: 'Geen voertuig',
    },
    grid: {
      _infoText:
        'Hier kunt u de klant zoeken en een directe bericht over de klant naar het voertuig sturen.',
      _showLogs: 'Logboeken tonen',
    },
  },
  newOrder: {
    days: {
      _monday: 'Maandag',
      _tuesday: 'Dinsdag',
      _wednesday: 'Woensdag',
      _thursday: 'Donderdag',
      _friday: 'Vrijdag',
      _saturday: 'Zaterdag',
      _sunday: 'Zondag',
    },
    frequency: {
      _oneTime: 'Eenmalig',
      _weekly: 'Wekelijks',
      _weeks: 'Elke # week',
    },
  },
  directMessages: {
    _messages: 'Berichten',
    _address: 'Adres',
    _sender: 'Afzender',
    _expires: 'Verloopt',
    _vehicle: 'Voertuig',
    _title: 'Titel',
    _message: 'Boodschap',
    _date: 'Datum',
    _closeButton: 'Sluiten',
    _sent: 'Verzonden',
    _received: 'Verwerkt',
    _read: 'Ontvangen',
    _status: 'Status',
    _newMessage: 'Nieuw bericht',
    _fromDate: 'Van',
    _toDate: 'Tot',
    _vehicles: 'Voertuigen',
    _chooseVehicles: 'Voertuig(en) kiezen',
    _statuses: 'Statussen',
    _chooseStatuses: 'Status(sen) kiezen',
  },
  depots: {
    _deleteConfirm: 'Weet u zeker dat u dit depot wilt verwijderen?',
    _deleteSuccess: 'Depot verwijderd',
    _depots: 'Depots',
    _newDepot: 'Nieuw depot',
    _id: 'Id',
    _customerId: 'Klant-Id',
    _description: 'Beschrijving',
    _latitude: 'Breedtegraad',
    _longitude: 'Lengtegraad',
    _depotCreated: 'Depot gemaakt',
    _depotUpdated: 'Depot bijgewerkt',
    _createNew: 'Nieuw depot maken',
    _update: 'Depot bijwerken',
    _submit: 'Opslaan',
    _cancelButton: 'Annuleren',
  },
  orderOverview: {
    _hideFilter: 'Filter verbergen',
    _showFilter: 'Filter tonen',
    _filter: 'Filter',
    _order: 'Bestelling',
    _date: 'Datum',
    _ordinaryDate: 'Gewoonlijke datum',
    _expires: 'Verloopt',
    _route: 'Route',
    _fractions: 'Fracties',
    _contractor: 'Aannemer',
    _status: 'Status',
    _dateFilterInvalid: 'Datumfilter is ongeldig',
    _from: 'Van',
    _to: 'Tot',
    _contractors: 'Aannemers',
    _orderNumber: 'Ordernummer',
    _routes: 'Routes',
    _chooseRoutes: 'Kies route(s)',
    _description: 'Beschrijving',
  },
  fractions: {
    _deleteConfirm: 'Weet u zeker dat u deze fractie wilt verwijderen?',
    _deleteSuccess: 'Fractie verwijderd',
    _newFraction: 'Nieuwe fractie',
    _fraction: 'Fractie',
    _fractions: 'Fracties',
    _picture: 'Afbeelding',
    _fractionCreated: 'Fractie aangemaakt',
    _fractionUpdated: 'Fractie bijgewerkt',
    _fractionName: 'Fractienaam',
    _updateFraction: 'Fractie bijwerken',
    _submit: 'Opslaan',
    _cancelButton: 'Annuleren',
    _selectImage: 'Selecteer een afbeelding',
  },
  units: {
    _units: 'Eenheden',
    _unitUpadated: 'Eenheid bijgewerkt',
    _unitName: 'Eenheidsnaam',
    _commune: 'Gemeente',
    _fractions: 'Breuken',
    _selectFractions: 'Selecteer breuken',
    _cancel: 'Annuleren',
    _save: 'Opslaan',
    _manageFractions: 'Beheer breuken',
    _shortName: 'Liter',
    _freeBasedProduct: 'Kostenproduct',
    _distance: 'Afstand',
    _container: 'Container',
  },
  calendar: {
    calendar: 'Kalender',
    listView: 'Lijstweergave',
    calendarView: 'Kalenderweergave',
    week: 'Week',
    month: 'Maand',
    workweek: 'Werkweek',
  },
  smartMap: {
    dashboard: {
      _agreements: 'Overeenkomsten',
      _places: 'Plaatsen',
      _bins: 'Bakjes',
      _routestops: 'Haltes',
      _unknown: 'Onbekend',
      _fractions: 'Fracties',
      _routes: 'Routes',
      _placeTypes: 'Plaatssoorten',
      _total: 'Totaal',
      _count: 'Aantal',
    },
    tabViews: {
      _dashboard: 'Dashboard',
      _agreements: 'Overeenkomsten',
      _places: 'Plaatsen',
      _bins: 'Bakjes',
    },
    _filterByShape: 'Filteren op vorm',
    _showData: 'Toon gegevens',
    actionOptions: {
      _sendTextMessage: 'Stuur sms-bericht',
    },
    grid: {
      _address: 'Adres',
      _estate: 'Landgoed',
      _name: 'Naam',
      _agreements: 'Overeenkomsten',
      _type: 'Type',
      _agreementId: 'Overeenkomst-ID',
    },
    _use: 'Gebruiken',
    _noAgreementsOnThisZoom:
      'We laden geen overeenkomsten op dit zoomniveau, zoom in om ze te laden.',
    _select: 'Selecteren',
    _route: 'Route',
    _filterByForm: 'Filter op selectie',
    _filterByRoutue: 'Filter op route(s)',
    _filterByExtent: 'Filter op kaartuitsnede',
    contextMenu: {
      _edit: 'Bewerken',
      _info: 'Info',
      _zoomIn: 'Inzoomen',
    },
  },
  orderExclusions: {
    _exclusionDays: 'Vrije dagen',
    _newExclusion: 'Vrije dag registreren',
    _deleteConfirm: 'Weet u zeker dat u deze vrije dag wilt verwijderen: ',
    _deleteSuccess: ' verwijderd',
    _name: 'Beschrijving',
    _date: 'Datum',
    _createSuccess: 'Vrije dag aangemaakt',
    _editSuccess: 'Vrije dag bijgewerkt',
    _newModalHeader: 'Nieuwe vrije dag registreren',
    _updateModalHeader: 'Vrije dag bewerken',
    _cancel: 'Annuleren',
    _save: 'Opslaan',
    _namePlaceHolder: 'Naam van vrije dag',
  },
  autoSequenceRoute: {
    _autosequenceRoute: 'Autovolgorde Route',
    _selectRoute: 'Selecteer route',
    _selectOrder: 'Selecteer order',
    _updateSequence: 'Update volgorde',
    _newSequence: 'Nieuwe volgorde',
    _oldSequence: 'Oude volgorde',
    _customerId: 'Klant-ID',
    _time: 'Tijd',
    _routeLineId: 'Routelijn-ID',
    _route: 'Route',
    _orderId: 'Order-ID',
    _paSystem: 'PA-systeem',
  },
  customerLogs: {
    _customerLogs: 'Klantlogboeken',
    _arrivalTime: 'Tijd',
    _executed: 'Uitgevoerd',
    _vehicle: 'Voertuig',
    _agreementId: 'Overeenkomst-ID',
    _address: 'Adres',
    _place: 'Plaats',
    _paSystem: 'PA-systeem',
    _externalOrderId: 'Ext.Best.ID',
    _logLineId: 'Logregel-ID',
    _pictures: "Foto's",
    _name: 'Naam',
    _driver: 'Bestuurder',
    _comment: 'Opmerking',
    _orderData: 'Bestelgegevens',
    _deviation: 'Afwijking / Opmerking',
    _item: 'Artikel',
  },
  surveyCreator: {
    _schemas: "Schema's",
    _saveSchema: 'Schema opslaan',
    _upsertSuccess: 'Schema opgeslagen',
  },
  surveyTypesPage: {
    _schemaTypes: 'Schema typen',
    _deleteConfirm: 'Weet u zeker dat u dit schema-type wilt verwijderen: ',
    _deleteSuccess: 'Schema-type verwijderd',
    _addNew: 'Nieuw schema-type toevoegen',
    _name: 'Naam',
    _key: 'Sleutel',
    _typeNameRequired: 'Naam van schema-type is verplicht',
    _typeKeyOptionRequired: 'Selecteer een schema-typeoptie',
    _typeKeyRequired: 'Container-ID is verplicht',
    _newSchemaType: 'Nieuw schema-type',
    _editSchemaType: 'Schema-type bewerken',
    _nameLabel: 'Naam van schema-type',
    _namePlaceHolder: 'Voer de naam van het schema-type in',
    _keyOptionLabel: 'Schema-typeoptie',
    _dayStart: 'Begin van de dag',
    _dayEnd: 'Einde van de dag',
    _containerRelated: 'Container gerelateerd',
    _keyPlaceholder: 'Voer container-ID in',
    _cancel: 'Annuleren',
    _submit: 'Verzenden',
    _createSuccess: 'Schema-type aangemaakt',
    _editSuccess: 'Schema-type bijgewerkt',
  },
  routeOverview: {
    _routeOverview: 'Routeoverzicht',
    _newRoute: 'Nieuwe route',
    _name: 'Naam',
    _active: 'Actief',
    _lastChanged: 'Laatst gewijzigd',
    _routeName: 'Routenaam',
    _routeId: 'Route-ID',
    _cancel: 'Annuleren',
    _save: 'Opslaan',
    _routeCreated: 'Route aangemaakt',
    _routeUpdated: 'Route bijgewerkt',
    _editRoute: 'Route bewerken',
    _routeIdAlreadyExits: 'Route-ID bestaat al',
    _activeRouteStops: 'Actieve routehaltes',
    _routeId: 'Route-ID',
    _system: 'Systeem',
    _export: 'Routehaltes exporteren',
    _import: 'Routehaltes importeren',
    _selectFileLabel: 'Selecteer een bestand om routehaltes te importeren',
    _selectFile: 'Bestand selecteren',
    _importRouteStops: 'Routehaltes importeren',
    _checkNonExistingAgreementLines: 'Niet-bestaande routehaltes controleren',
    _validate: 'Valideren',
    _nonExistingAgreementLineIdWarningText:
      'De volgende agreement line-ID’s bestaan niet:',
    _importRouteStopsValidationSuccess: 'Validatie geslaagd',
    _validationError: 'Validatiefout:',
    _clearAllRouteStops: 'Alle route-stops verwijderen',
    _confirmDeleteAllRouteStops:
      'Weet je zeker dat je alle route-stops wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
    _routeStopsCleared: 'Alle route-stops zijn verwijderd.',
    _validationErrorAllLinesSameRoute:
      'Alle routehaltes moeten tot dezelfde route behoren.',
    _validationErrorNoRouteId: 'Alle routehaltes moeten een route-ID hebben.',
    _validationErrorActiveRouteStops:
      'Kan geen routehaltes importeren naar een route die al actieve routehaltes heeft.',
    _validationErrorRouteDoesNotExist: 'Route bestaat niet.',
  },
  pdaSettings: {
    _pdaSettings: 'Gegevensknoppen',
    _parameter: 'Parameter',
    _valueNO: 'Waarde NO',
    _valueENG: 'Waarde ENG',
    _minValue: 'Minimumwaarde',
    _maxValue: 'Maximumwaarde',
    _required: 'Vereist',
    _lastChanged: 'Laatst gewijzigd',
    _newPDASetting: 'Nieuwe PDA-instelling',
    _udatePDASetting: 'PDA-instelling bijwerken',
    _cancel: 'Annuleren',
    _save: 'Opslaan',
    _createSuccess: 'PDA-instelling aangemaakt',
    _updateSuccess: 'PDA-instelling bijgewerkt',
    _notAnyRecords: 'Er zijn geen PDA-instellingen',
    _parameterAlreadyExits: 'Parameter bestaat al',
  },
  timeUsageReport: {
    _header: 'Tijdgebruikrapport',
    _orderName: 'Opdrachtnaam',
    _orderDate: 'Opdrachtdatum',
    _effectiveTime: 'Effectieve tijd',
    _usageTime: 'Gebruikstijd',
    _fractions: 'Fracties',
    _time: 'Tijd (minuten)',
    _minutes: 'min',
    _tableView: 'Tabelweergave',
    _diagramView: 'Diagrammen',
  },
  drivers: {
    _header: 'Chauffeurs',
    _driver: 'Chauffeursnaam',
    _firstName: 'Voornaam',
    _lastName: 'Achternaam',
    _phoneNr: 'Telefoonnummer',
    _active: 'Actief',
    _contractors: 'Aannemers',
    _newDriver: 'Nieuwe chauffeur',
    _deleted: 'Chauffeur verwijderd',
    _noDrivers: 'Er zijn geen chauffeurs',
    _alreadyExist: 'Chauffeursnaam bestaat al',
    _created: 'Chauffeur aangemaakt',
    _updated: 'Chauffeur bijgewerkt',
    _createNew: 'Nieuwe chauffeur maken',
    _update: 'Chauffeur bijwerken',
    _password: 'Wachtwoord',
    _cancel: 'Annuleren',
    _save: 'Opslaan',
    _deleteConfirm: 'Weet u zeker dat u deze chauffeur wilt verwijderen: ',
  },
};
